const MAINTENANCE_BYPASS_STORAGE_KEY = "maintenanceBypassUntil";
const MAINTENANCE_BYPASS_DURATION_MS = 10 * 60 * 1000;

const getStoredBypassUntil = (): number | null => {
  if (typeof window === "undefined") {
    return null;
  }

  const rawValue = window.sessionStorage.getItem(MAINTENANCE_BYPASS_STORAGE_KEY);
  if (!rawValue) {
    return null;
  }

  const parsed = Number.parseInt(rawValue, 10);
  if (!Number.isFinite(parsed) || parsed <= 0) {
    window.sessionStorage.removeItem(MAINTENANCE_BYPASS_STORAGE_KEY);
    return null;
  }

  return parsed;
};

export const isMaintenanceBypassActive = (): boolean => {
  const bypassUntil = getStoredBypassUntil();
  if (!bypassUntil) {
    return false;
  }

  if (Date.now() >= bypassUntil) {
    window.sessionStorage.removeItem(MAINTENANCE_BYPASS_STORAGE_KEY);
    return false;
  }

  return true;
};

export const activateMaintenanceBypass = (): void => {
  if (typeof window === "undefined") {
    return;
  }

  window.sessionStorage.setItem(
    MAINTENANCE_BYPASS_STORAGE_KEY,
    String(Date.now() + MAINTENANCE_BYPASS_DURATION_MS)
  );
};
